module.exports = __webpack_public_path__ + "unsupported-page-image-3ef3df86.jpg";